import { useSelector } from "react-redux";

import messages from "../../../../../../assets/locale/messages";
import waitDocsImg from "../../../../../../assets/images/vectors/wait-docs.png";
import EmptyState from "../../../../../../components/EmptyState";
import { Box } from "@mui/material";

const WaitingDocumentsUpload = () => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      requestDetails: {
        offplatformRequest: { waitUploadDocs }
      }
    }
  } = messages[lang];

  return (
    <div className="waiting-off-platform-documents-upload">
      <Box
        className="pt-4"
        sx={{
          margin: "0 auto",
          width: {
            xs: "100%",
            md: "60%"
          }
        }}>
        <EmptyState
          subTitle={waitUploadDocs.docsRequestedTitle}
          description={waitUploadDocs.docsRequestedMsg}
          imgSrc={waitDocsImg}
        />
      </Box>
    </div>
  );
};

export default WaitingDocumentsUpload;
